<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Cập nhật đơn vị cung cấp</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">

          <b-row v-if="mData.ifHavePermission">
            <b-col md="6">
              <el-form-item label="Tên đơn vị" prop>
                <el-input type="text" v-model="mData.dataForm.thong_tin_chung.ten"
                  :disabled="mData.viewMode == 'detail'" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Số điện thoại người đăng ký" prop>
                <el-input type="text" v-model="
                  mData.dataFormOther.nguoi_dai_dien.dien_thoai
                " :disabled="mData.viewMode == 'detail'" clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="thong_tin_chung.anh">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Địa chỉ
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseDiaChi v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="6">
                      <b-row>
                        <b-col md="6">
                          <el-form-item label="Tỉnh/Thành phố" prop>
                            <el-select @change="fn_initDataDistrict(mData.dataFormOther.dia_chi.tinh_id)"
                              v-model="mData.dataFormOther.dia_chi.tinh_id" :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'" clearable filterable default-first-option>
                              <el-option v-for="item in mData.dataDefault.listProvince" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="Quận/huyện" prop>
                            <el-select @change="fn_initDataCommune(mData.dataFormOther.dia_chi.huyen_id)"
                              v-model="mData.dataFormOther.dia_chi.huyen_id" :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'" clearable filterable default-first-option>
                              <el-option v-for="item in mData.dataDefault.listDistrict" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="Xã/Phường" prop>
                            <el-select v-model="mData.dataFormOther.dia_chi.xa_id" :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listCommune" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Địa chỉ" prop>
                            <el-input type="text" v-model="mData.dataFormOther.dia_chi.dia_chi"
                              :disabled="mData.viewMode == 'detail'" clearable></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col>
                          <el-form-item label="Địa chỉ trên bản đồ" prop>
                            <mapbox-component @update="fn_getDataFromMapboxComponent"
                              :cordinatesValue="mData.mapDataObject.value" :prop-disabled="mData.viewMode == 'update'"
                              v-if="mData.dataDefault.showMap" id="mapBox"></mapbox-component>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
                <el-form-item class="text-center mt-3">
                  <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="!mData.isTicket">{{
                    aLang.c_update
                  }}</el-button>
                  <el-button type="info" plain @click="fn_submitForm('updateTicket')" v-ladda v-if="mData.isTicket">{{
                    aLang.c_update
                  }}</el-button>

                  <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
                </el-form-item>
              </b-card>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DDATModel from "./DDATModel";
import InfoVeDienTuApi from '@/moduleApi/InfoVeDienTuApi';
import InfoDiemDenApi from '@/moduleApi/InfoDiemDenApi';
import MapComponent from "../../../component/MapComponent";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import MapboxComponent from "../../../component/MapboxComponent";
import SurveyApi from "../../../moduleApi/SurveyApi";

export default {
  components: {
    MapComponent,
    MapboxComponent,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "update",
        moduleName: "ThongTinDDAT", //requied
        urlImg: ExtensionService.urlSurveyImg,
        tableRules: MethodService.copyObject(DDATModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          showMap: false,
          listGioiTinh: DataService.gioiTinh,
          listCountry: [],
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listTieuChiAnToan: [],
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          listImageUrl: [],
        },
        dataForm: MethodService.copyObject(DDATModel.dataForm),
        dataFormOther: MethodService.copyObject(DDATModel.dataFormOther),
        ifHavePermission: false,
        isTicket: false,
        validForm: DDATModel.validForm,
        validFormOther: DDATModel.validFormOther,
        fileUploadOption: {
          //MethodService.copyObject(DDATModel.dataFormOther.fileUploadOption),
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          AnhGiayTo: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        configChart: {
          title: "",
          titleX: "Ngày",
          titleY: "Số lượt",
          dataPoint: [],
        },
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "update") {
            data.id = this.$router.currentRoute.params.id;
            data.thong_tin_chung.dia_chi.kinh_do = this.mData.mapDataObject.value[0];
            data.thong_tin_chung.dia_chi.vi_do = this.mData.mapDataObject.value[1];
            await InfoDiemDenApi.update(data);
            this.$router.push("/admin/ThongTinDDAT/detail");
          }
          if (type === "updateTicket") {
            data.id = this.$router.currentRoute.params.id;
            data.thong_tin_chung.dia_chi.kinh_do = this.mData.mapDataObject.value[0];
            data.thong_tin_chung.dia_chi.vi_do = this.mData.mapDataObject.value[1];
            await InfoVeDienTuApi.update(data);
            this.$router.push("/admin/ThongTinDDAT/detail");
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //get list table
    async fn_initTable() {
      let currentUser = MethodService.getCurrentUser();

      let dataFilter = {
        filters: "nguoi_tao_id=" + currentUser.id,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-update"
        }).catch(() => { });
      }
      if (
        currentUser.roles.includes("Ticket")
      ) {
        this.mData.ifHavePermission = true;
        this.mData.isTicket = true;
        let res = await InfoVeDienTuApi.list(dataFilter);
        if (res.result && res.result.length > 0) {
          let resGiayTo = {};
          let resDiaChi = {};
          let resNguoiDaiDien = {};
          let resForm = {};

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.anh
          ) {
            let data = {};
            if (JSON.parse(localStorage.getItem('currentUser')).roles.includes('Destination') || JSON.parse(localStorage.getItem('currentUser')).roles.includes('Ticket')) {
              data = {
                id: res.result[0].thong_tin_chung.anh,
                name: res.result[0].thong_tin_chung.anh,
                url: ExtensionService.urlImg + res.result[0].thong_tin_chung.anh + "&r=square&w=512"
              };
            } else {
              data = {
                id: res.result[0].thong_tin_chung.anh,
                name: res.result[0].thong_tin_chung.anh,
                url: ExtensionService.urlSurveyImg + res.result[0].thong_tin_chung.anh + "&r=square&w=512"
              };
            }
            this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.giay_to &&
            res.result[0].thong_tin_chung.giay_to.scan
          ) {
            var data = [];
            let listImage = [];
            for (
              let i = 0;
              i < res.result[0].thong_tin_chung.giay_to.scan.length;
              i++
            ) {
              let fileInfo = await SurveyApi.getFile(
                res.result[0].thong_tin_chung.giay_to.scan[i]
              );
              let item = {};
              if (fileInfo.result) {
                item = fileInfo.result;
              } else {
                item = {
                  id: res.result[0].thong_tin_chung.giay_to.scan[i],
                  name: res.result[0].thong_tin_chung.giay_to.scan[i],
                };
              }
              item.url =
                ExtensionService.urlSurveyImg +
                res.result[0].thong_tin_chung.giay_to.scan[i];
              let url =
                ExtensionService.urlSurveyImg +
                res.result[0].thong_tin_chung.giay_to.scan[i];
              data.push(item);
              listImage.push(url);
            }
            this.mData.dataDefault.listImageUrl = listImage;
            this.mData.fileUploadOption.AnhGiayTo.fileList = data;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.giay_to &&
            res.result[0].thong_tin_chung.giay_to != null
          ) {
            resGiayTo = MethodService.checkDifferentObject(
              MethodService.copyObject(DDATModel.dataFormOther.giay_to),
              res.result[0].thong_tin_chung.giay_to
            );
          } else {
            resGiayTo = MethodService.copyObject(
              DDATModel.dataFormOther.giay_to
            );
          }
          if (
            res.result[0].du_lieu_khai_bao &&
            res.result[0].du_lieu_khai_bao.giay_to_ngay_cap
          ) {
            resGiayTo.ngay_cap = MethodService.formatDate(
              res.result[0].du_lieu_khai_bao.giay_to_ngay_cap,
              "date"
            );
          }
          this.mData.dataFormOther.giay_to = resGiayTo;
          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.kinh_do &&
            res.result[0].thong_tin_chung.dia_chi.vi_do
          ) {
            this.mData.dataPropMapDiaDiem.lat =
              res.result[0].thong_tin_chung.dia_chi.vi_do;
            this.mData.dataPropMapDiaDiem.lng =
              res.result[0].thong_tin_chung.dia_chi.kinh_do;
            this.mData.dataPropMapDiaDiem.showMap = true;

            let coordinate = [
              res.result[0].thong_tin_chung.dia_chi.kinh_do,
              res.result[0].thong_tin_chung.dia_chi.vi_do,
            ];
            this.mData.mapDataObject.value = coordinate;
            this.mData.mapDataObject.geoJson.type = "Point";
            this.mData.mapDataObject.geoJson.coordinates = coordinate;
            this.mData.dataDefault.showMap = true;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.tinh_id
          ) {
            let resProvince = await ProvinceApi.findById(
              res.result[0].thong_tin_chung.dia_chi.tinh_id
            );
            this.mData.dataDefault.listProvince.push(resProvince.result);
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.huyen_id
          ) {

            let resDistrict = await DistrictApi.list({
              limit: 1000,
              filters: 'provinceId=' + res.result[0].thong_tin_chung.dia_chi.tinh_id
            });
            this.mData.dataDefault.listDistrict = resDistrict.result;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.xa_id
          ) {
            let resCommune = await CommuneApi.list({
              limit: 1000,
              filters: 'districtId=' + res.result[0].thong_tin_chung.dia_chi.huyen_id

            });
            this.mData.dataDefault.listCommune = resCommune.result;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi != null
          ) {
            resDiaChi = MethodService.checkDifferentObject(
              MethodService.copyObject(DDATModel.dataFormOther.dia_chi),
              res.result[0].thong_tin_chung.dia_chi
            );
          } else {
            resDiaChi = MethodService.copyObject(
              DDATModel.dataFormOther.dia_chi
            );
          }

          this.mData.dataFormOther.dia_chi = resDiaChi;

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.nguoi_dai_dien &&
            res.result[0].thong_tin_chung.nguoi_dai_dien != null
          ) {
            resNguoiDaiDien = MethodService.checkDifferentObject(
              MethodService.copyObject(
                DDATModel.dataFormOther.nguoi_dai_dien
              ),
              res.result[0].thong_tin_chung.nguoi_dai_dien
            );
          } else {
            resNguoiDaiDien = MethodService.copyObject(
              DDATModel.dataFormOther.nguoi_dai_dien
            );
          }

          this.mData.dataFormOther.nguoi_dai_dien = resNguoiDaiDien;

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.nguoi_dai_dien &&
            res.result[0].thong_tin_chung.nguoi_dai_dien != null
          ) {
            resForm = MethodService.checkDifferentObject(
              MethodService.copyObject(DDATModel.dataForm),
              res.result[0]
            );
          } else {
            resForm = MethodService.copyObject(DDATModel.dataForm);
          }

          let tenLoai = this.mData.dataDefault.listLoaiHinh.find(
            (element) => element.code == resForm.loai_diem_den
          );
          if (tenLoai) {
            resForm.ten_loai_diem_den = tenLoai.text;
          } else {
            resForm.ten_loai_diem_den = "";
          }
          this.mData.dataForm = resForm;
          if (this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do == null ||
            this.mData.dataForm.thong_tin_chung.dia_chi.vi_do == null
          ) {
            this.mData.dataPropMapDiaDiem.lng = 105.850176;
            this.mData.dataPropMapDiaDiem.lat = 21.0287797;
            this.mData.dataPropMapDiaDiem.showMap = true;

            let coordinate = [
              105.850176,
              21.0287797
            ];
            this.mData.showMap = true;
            this.mData.mapDataObject.value = coordinate;
            this.mData.mapDataObject.geoJson.type = "Point";
            this.mData.mapDataObject.geoJson.coordinates = coordinate;
            this.mData.dataDefault.showMap = true;
          }
        }

      } else if (
        currentUser.roles.includes("Destination")
      ) {
        this.mData.ifHavePermission = true;
        this.mData.isTicket = false;
        let res = await InfoDiemDenApi.list(dataFilter);
        if (res.result && res.result.length > 0) {
          let resGiayTo = {};
          let resDiaChi = {};
          let resNguoiDaiDien = {};
          let resForm = {};

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.anh
          ) {
            let data = {};
            if (JSON.parse(localStorage.getItem('currentUser')).roles.includes('Destination') || JSON.parse(localStorage.getItem('currentUser')).roles.includes('Ticket')) {
              data = {
                id: res.result[0].thong_tin_chung.anh,
                name: res.result[0].thong_tin_chung.anh,
                url: ExtensionService.urlImg + res.result[0].thong_tin_chung.anh + "&r=square&w=512"
              };
            } else {
              data = {
                id: res.result[0].thong_tin_chung.anh,
                name: res.result[0].thong_tin_chung.anh,
                url: ExtensionService.urlSurveyImg + res.result[0].thong_tin_chung.anh + "&r=square&w=512"
              };
            }
            this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.giay_to &&
            res.result[0].thong_tin_chung.giay_to.scan
          ) {
            let data = [];
            let listImage = [];
            for (
              let i = 0;
              i < res.result[0].thong_tin_chung.giay_to.scan.length;
              i++
            ) {
              let fileInfo = await SurveyApi.getFile(
                res.result[0].thong_tin_chung.giay_to.scan[i]
              );
              let item = {};
              if (fileInfo.result) {
                item = fileInfo.result;
              } else {
                item = {
                  id: res.result[0].thong_tin_chung.giay_to.scan[i],
                  name: res.result[0].thong_tin_chung.giay_to.scan[i],
                };
              }
              item.url =
                ExtensionService.urlSurveyImg +
                res.result[0].thong_tin_chung.giay_to.scan[i];
              let url =
                ExtensionService.urlSurveyImg +
                res.result[0].thong_tin_chung.giay_to.scan[i];
              data.push(item);
              listImage.push(url);
            }
            this.mData.dataDefault.listImageUrl = listImage;
            this.mData.fileUploadOption.AnhGiayTo.fileList = data;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.giay_to &&
            res.result[0].thong_tin_chung.giay_to != null
          ) {
            resGiayTo = MethodService.checkDifferentObject(
              MethodService.copyObject(DDATModel.dataFormOther.giay_to),
              res.result[0].thong_tin_chung.giay_to
            );
          } else {
            resGiayTo = MethodService.copyObject(
              DDATModel.dataFormOther.giay_to
            );
          }
          if (
            res.result[0].du_lieu_khai_bao &&
            res.result[0].du_lieu_khai_bao.giay_to_ngay_cap
          ) {
            resGiayTo.ngay_cap = MethodService.formatDate(
              res.result[0].du_lieu_khai_bao.giay_to_ngay_cap,
              "date"
            );
          }
          this.mData.dataFormOther.giay_to = resGiayTo;
          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.kinh_do &&
            res.result[0].thong_tin_chung.dia_chi.vi_do
          ) {
            this.mData.dataPropMapDiaDiem.lat =
              res.result[0].thong_tin_chung.dia_chi.vi_do;
            this.mData.dataPropMapDiaDiem.lng =
              res.result[0].thong_tin_chung.dia_chi.kinh_do;
            this.mData.dataPropMapDiaDiem.showMap = true;

            let coordinate = [
              res.result[0].thong_tin_chung.dia_chi.kinh_do,
              res.result[0].thong_tin_chung.dia_chi.vi_do,
            ];
            this.mData.mapDataObject.value = coordinate;
            this.mData.mapDataObject.geoJson.type = "Point";
            this.mData.mapDataObject.geoJson.coordinates = coordinate;
            this.mData.dataDefault.showMap = true;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.tinh_id
          ) {
            let resProvince = await ProvinceApi.findById(
              res.result[0].thong_tin_chung.dia_chi.tinh_id
            );
            this.mData.dataDefault.listProvince.push(resProvince.result);
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.huyen_id
          ) {
            let resDistrict = await DistrictApi.list({
              limit: 1000,
              filters: 'provinceId=' + res.result[0].thong_tin_chung.dia_chi.tinh_id
            });

            this.mData.dataDefault.listDistrict = resDistrict.result;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi.xa_id
          ) {
            let resCommune = await CommuneApi.list({
              limit: 1000,
              filters: 'districtId=' + res.result[0].thong_tin_chung.dia_chi.huyen_id

            });

            this.mData.dataDefault.listCommune = resCommune.result;
          }

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.dia_chi &&
            res.result[0].thong_tin_chung.dia_chi != null
          ) {
            resDiaChi = MethodService.checkDifferentObject(
              MethodService.copyObject(DDATModel.dataFormOther.dia_chi),
              res.result[0].thong_tin_chung.dia_chi
            );
          } else {
            resDiaChi = MethodService.copyObject(
              DDATModel.dataFormOther.dia_chi
            );
          }

          this.mData.dataFormOther.dia_chi = resDiaChi;

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.nguoi_dai_dien &&
            res.result[0].thong_tin_chung.nguoi_dai_dien != null
          ) {
            resNguoiDaiDien = MethodService.checkDifferentObject(
              MethodService.copyObject(
                DDATModel.dataFormOther.nguoi_dai_dien
              ),
              res.result[0].thong_tin_chung.nguoi_dai_dien
            );
          } else {
            resNguoiDaiDien = MethodService.copyObject(
              DDATModel.dataFormOther.nguoi_dai_dien
            );
          }

          this.mData.dataFormOther.nguoi_dai_dien = resNguoiDaiDien;

          if (
            res.result[0].thong_tin_chung &&
            res.result[0].thong_tin_chung.nguoi_dai_dien &&
            res.result[0].thong_tin_chung.nguoi_dai_dien != null
          ) {
            resForm = MethodService.checkDifferentObject(
              MethodService.copyObject(DDATModel.dataForm),
              res.result[0]
            );
          } else {
            resForm = MethodService.copyObject(DDATModel.dataForm);
          }

          let tenLoai = this.mData.dataDefault.listLoaiHinh.find(
            (element) => element.code == resForm.loai_diem_den
          );
          if (tenLoai) {
            resForm.ten_loai_diem_den = tenLoai.text;
          } else {
            resForm.ten_loai_diem_den = "";
          }
          this.mData.dataForm = resForm;
          if (this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do == null ||
            this.mData.dataForm.thong_tin_chung.dia_chi.vi_do == null
          ) {
            this.mData.dataPropMapDiaDiem.lng = 105.850176;
            this.mData.dataPropMapDiaDiem.lat = 21.0287797;
            this.mData.dataPropMapDiaDiem.showMap = true;

            let coordinate = [
              105.850176,
              21.0287797
            ];
            this.mData.showMap = true;
            this.mData.mapDataObject.value = coordinate;
            this.mData.mapDataObject.geoJson.type = "Point";
            this.mData.mapDataObject.geoJson.coordinates = coordinate;
            this.mData.dataDefault.showMap = true;
          }
        }
      }
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },
    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "daily") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-daily",
          params: { id: row.id },
        });
      }
    },

    //event table

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      var roles = "";
      cellValue.forEach((item) => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataProvince() {
      let tinh_thanh = await ProvinceApi.list({
        limit: 1000
      });
      this.mData.dataDefault.listProvince = tinh_thanh.result;
    },
    async fn_initDataDistrict(id) {
      let quan_huyen = await DistrictApi.list({
        limit: 1000,
        filters: 'provinceId=' + id
      });

      this.mData.dataFormOther.dia_chi.huyen_id = "";
      this.mData.dataFormOther.dia_chi.xa_id = "";
      this.mData.dataDefault.listDistrict = quan_huyen.result;
    },
    async fn_initDataCommune(districtId) {
      let thon_xa = await CommuneApi.list({
        limit: 1000,
        filters: 'districtId=' + districtId

      });
      this.mData.dataFormOther.dia_chi.xa_id = "";
      this.mData.dataDefault.listCommune = thon_xa.result;
    },

    fn_hashUrl() {
    },
    fn_download(file) {
      window.open(ExtensionService.urlSurveyFile + file.id);
    },
    fn_go() {
      this.$router.go(-1);
    },
    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.thong_tin_chung.anh = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("thong_tin_chung.anh");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "DDAT")
        .then(res => {
          this.mData.dataForm.thong_tin_chung.anh = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("thong_tin_chung.anh");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("thong_tin_chung.anh");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
  },

  //run after render view
  created() {
    if (!this.$route.params.id) {
      this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: {id: window.localStorage.getItem('tv_don_vi_cung_caps') }
        }).catch(() => { });
    }
    this.fn_initDataProvince();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>
<style lang="scss">
::v-deep .el-link {
  display: flex !important;
  justify-content: flex-start !important;
}

::v-deep .el-link--inner {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-message-box {
  width: 95%;

  @media (min-width: 576px) {
    width: 420px;
  }
}
</style>
